<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'user-project-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>

      <v-data-table
        :headers="headers"
        :items="users"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.name }}<br>
            <small>{{ props.item.email }}</small>
          </td>
          <td>
            <ul>
              <li v-for="project in props.item.projects" :key="`prt_${project.id}`">
                {{ project.name }}
              </li>
            </ul>
          </td>
          <td class="text-xs-center">

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" 
              @click="deleteData({
                id: props.item.id,
                name: props.item.name,
              })">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import UserService from '@/features/user/UserService';

export default {
  name: 'user-project-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('attributes.userProject'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.projects'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
      users: [],
    };
  },
  methods: {
    initCrud() {
      this.serviceType = UserService;
      this.routerName = 'user-project';
      this.onSearchInit = false;
    },
    async fetchUsersWithProjects() {
      const response = await this.service.request(
        'GET',
        'get-all-with-projects',
      );
      this.users = response.data;
    },
    deleteData({ id, name }) {
      this.$dialog.confirm({ title: 'Atenção', content: `Deseja remover os projetos de ${name}?` })
        .then(async (response) => {
          if (response.action === 'ok') {
            await this.service.request(
              'DELETE',
              'detach-projects',
              null,
              { params: { id } },
            );
            this.fetchUsersWithProjects();
            this.$toast.success(this.$t('messages.removeSuccess'));
          }
        });
    },
  },
  beforeMount() {
    this.fetchUsersWithProjects();
  },
};
</script>



// WEBPACK FOOTER //
// src/features/user-project/UserProjectList.vue